/**
 * Loads and parses the iSchedule JSON data from the page.
 * Returns null if the data cannot be found or parsed.
 */
function loadIscheduleData() {
	// Grab the <script> element by its ID
	const jsonEl = document.getElementById('ischedule-json');
	if (!jsonEl) {
		console.warn('iSchedule JSON data not found!');
		return null;
	}
	
	// Parse the JSON text into a JS object
	let ischeduleData;
	try {
		ischeduleData = JSON.parse(jsonEl.textContent);
		console.log(ischeduleData);
		return ischeduleData;
	} catch (e) {
		console.error('Failed to parse iSchedule JSON:', e);
		return null;
	}
}

// Load and export the data
export const ischeduleData = loadIscheduleData();